import { UUID } from 'crypto';
import { DEBUG } from '../..';

export type Product = {
  name: string;
  value: number;
  tax: number;
  discount: Discount;
};

export type Discount = {
  discount: number;
  start: Date;
  end: Date;
  affiliate: string;
};

export type CartItem = {
  product: Product;
  quantity: number;
  upgradeKey: string | null;
};

export class Cart {
    Items: CartItem[] = [];
    public Quantity(){
      var quantity = 0;
      for(var i = 0; i < this.Items.length; i++)
        quantity += this.Items[i].quantity;
      return quantity;
    };
    constructor(defaultProduct: Product){
        this.Items = [{product: defaultProduct, quantity: 0, upgradeKey: null}];
    }

    public UpdateNewQuantity(quantity: number){
        if(quantity < 0) return;
        this.Items[0].quantity = quantity;
    }

    public AddUpgradeKey(product: Product, upgradeKey: string) {
        if (this.Items.some(item => item.upgradeKey === upgradeKey)) this.RemoveUpgradeKey(upgradeKey);
        else this.Items.push({product: product, quantity: 1, upgradeKey: upgradeKey})
    }
    
    public RemoveUpgradeKey(upgradeKey: string) {
        var idx = this.Items.findIndex(item => item.upgradeKey == upgradeKey)
        if(idx >= 0)
            this.Items.splice(idx, 1);
    }

    public HasUpgradeKey(upgradeKey: string){
      if(DEBUG) console.log("Check key existing");
      var result = this.Items.some(item => item.upgradeKey === upgradeKey);
      
      if(DEBUG) console.log(result);
      if(DEBUG) console.log(upgradeKey);
      if(DEBUG) console.log(this.Items);
      return result;
    }
}